<template>
  <div class="request-card-wrapper">
    <transition name="stretch" mode="out-in">
      <div v-if="showRequestsBtns" key="open">
        <div class="playlist-request-btn-list">
          <div class="request-close-wrapper">
            <div class="request-close-btn" @click="requestBtnClicked()">
              <span>&#215;</span>
            </div>
          </div>
          <div v-for="playlist in playlists" :style="{ 'background-color': backgroundColor, 'position': 'relative' }">
            <button @mouseover="isHovering = true" @mouseout="isHovering = false" @click="toggleRequest(playlist.id)"
              :class="[playlist.name.length > 25 ? { hovering: isHovering } : '', requested(playlist.id) ? 'black-btn' : 'transparent-btn']"
              class="btn-lg playlist-request-btn">{{ getPlaylistName(playlist) }}</button>
            <div v-if="playlist.name.length > 25" class="cstmTooltip-container">
              <div class="inner">
                <p>{{ getPlaylistName(playlist) }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-placeholder"></div>
      </div>
      <div v-else key="close">
        <button class="btn-lg request-btn" @click="requestBtnClicked()"
          v-bind:class="requestedPlaylistIds.length ? 'black-btn' : 'transparent-btn'">
          <span v-if="requestedPlaylistIds.length">Requested</span>
          <span v-else>Request</span>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    coffee: Object,
    playlists: Array,
    requestedPlaylistIdsProp: Array,
    backgroundColor: String
  },
  data: function () {
    return {
      showRequestsBtns: false,
      requestedPlaylistIds: this.requestedPlaylistIdsProp,
      isHovering: false
    }
  },
  methods: {
    toggleRequest(playlistId) {
      const newRequest = !this.requested(playlistId);
      newRequest ? this.requestedPlaylistIds.push(playlistId) : this.removePlaylistId(playlistId);
      this.$api.post('update-request', {
        coffeeId: this.coffee.id,
        playlistId,
        requested: newRequest
      })
        .then()
        .catch(() => { });
    },
    requested(playlistId) {
      return this.requestedPlaylistIds && this.requestedPlaylistIds.includes(playlistId);
    },
    removePlaylistId(playlistId) {
      this.requestedPlaylistIds = this.requestedPlaylistIds.filter(r => r !== playlistId);
    },
    getPlaylistName(playlist) {
      // Add location name if there is the same playlist name
      // if (this.playlists.find(p => p.name === playlist.name && p.id === playlist.id)) {
      return `${playlist.location.name}: ${playlist.name}`;
      // }

      // return playlist.name
    },
    requestBtnClicked() {
      if (this.playlists.length === 1) {
        this.toggleRequest(this.playlists[0].id);
        return;
      }

      this.showRequestsBtns = !this.showRequestsBtns;
    },
  }
}
</script>

<style scoped>
.request-card-wrapper {
  min-height: 100px;
}

.request-close-wrapper {
  width: 300px;
  height: 20px;
}

.playlist-request-btn-list {
  position: absolute;
  bottom: 0;
  width: 300px;
  margin-bottom: 3rem;
  max-height: 1000px;
}

.request-close-btn {
  float: right;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  background-color: #1F323B;
  text-align: center;
  font-size: 22px;
  color: white;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.btn-placeholder {
  height: 84px;
}

.playlist-request-btn {
  margin: 0.5rem 0;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.request-btn {
  margin: 1.5rem 0;
  max-width: 300px;
}

.stretch-enter-active,
.stretch-leave-active {
  transition: all .4s ease;
  max-height: 1000px;
}

.stretch-enter,
.stretch-leave-to {
  max-height: 0;
  opacity: 0;
}

/* Tooltip Starts */

.cstmTooltip-container {
  background: #142127;
  color: #fff;
  font-size: 13px;
  padding: 8px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 63px;
  margin: 0 auto;
  z-index: 99;
  border: none;
  opacity: 0;
  visibility: hidden;
  transition: 300ms ease-in;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -ms-transition: 300ms ease-in;
  transform: translateY(-10px);
}

.cstmTooltip-container:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 7px solid #142127;
  bottom: -7px;
}

.hovering:hover~.cstmTooltip-container {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}
</style>